//@flow
import type {BlogCategory} from '../../../entities';

export const BLOG_FORM_FIELDS = {
  title: 'title',
  enabled: 'enabled',
  author: 'author',
  categories: 'categories',
  url: 'url',
  urlIsCustom: 'urlIsCustom',
  poster: 'poster',
  posterAlt: 'posterAlt',

  posterPreview: 'posterPreview',
  postFeatured: 'postFeatured',

  seoTitle: 'seoTitle',
  seoDescription: 'seoDescription',
  content: 'content',
  getContentField: (index: number) => ({
    subtitle: `content[${index}].subtitle`,
    text: `content[${index}].text`,
    getImageField: (imageIndex: number) => ({
      image: `content[${index}].images[${imageIndex}].image`,
      alt: `content[${index}].images[${imageIndex}].alt`,
    }),
  }),
  relatedEntities: 'relatedEntities',
  enabledRelatedEntities: 'enabledRelatedEntities',
};

export type BlogFormFieldsContent = {
  subtitle: string,
  text: string,
  images: {
    image?: File | string,
    alt?: string,
    preview?: string,
  }[],
};

export type BlogFormFieldsRelatedObject = {
  blogEntityType: 'PRODUCT' | 'CATEGORY' | 'SUBCATEGORY',
  entityIdentifier: string,
};
export type BlogFormFields = {
  title: string,
  author: string,
  enabled: boolean,
  categories: BlogCategory[],
  url: string,
  urlIsCustom?: boolean,
  poster: File,
  posterAlt?: string,
  seoTitle?: string,
  seoDescription?: string,
  content: BlogFormFieldsContent[],
  relatedEntities?: BlogFormFieldsRelatedObject[],
  enabledRelatedEntities?: boolean,
  postFeatured?: boolean,
};

export const getDefaultContentSegment = () => ({
  subtitle: '',
  text: '',
  images: [
    {
      image: undefined,
      alt: '',
    },
    {
      image: undefined,
      alt: '',
    },
  ],
});

export function validateBlogSections(section: BlogFormFieldsContent) {
  const {subtitle, text} = section;

  if (!subtitle) {
    /* return {
      valid: false,
      message: 'El subtítulo es requerido',
    }; */
    return false;
  }

  if (!text) {
    /* return {
      valid: false,
      message: 'El texto es requerido',
    }; */
    return false;
  }

  /* return {
    valid: true,
  }; */
  return true;
}

export const BLOG_ERROR_MESSAGE_MAP = {
  MaxFeaturedPostsLimitExceeded: 'No se pueden tener más de 4 posts destacados',
  MaxPostsLimitExceeded: 'No se pueden tener más de 10 posts',
  'The slug already exist': 'La URL ya existe',
};
